import React, { useState } from "react";
import './write-to-us.scss'
import CallIcon from '../../../assets/images/write-to-us-call.svg'
import CloseIcon from '../../../assets/images/write-to-us-close.svg'
import SubmitCheckbox from '../../../assets/images/submit-checkbox.svg'
import { Button, Row } from "antd";
import { useTranslation } from "react-i18next";

import { message } from "antd";
import { useStore } from "../../../store/store";
import { RaiseComplaints } from "../../../service/helpAndSupport/helpAndSupportService";
import { SendHelpSupportMail } from "../../../service/helpAndSupport/helpAndSupportService";

const WriteToUs = ({ setOpenWriteToUsModel, modalTitle, modalDescription }) => {
    const { t } = useTranslation();
    const { user } = useStore();
    const [submitModel, setSubmitModel] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [complaintId, setComplainId] = useState("")
        const [submitButtonLoader, setsubmitButtonLoader] = useState(false);

    const handleOutsideClick = (e) => {
        if (e.target.id === "write-to-us-wrapper") {
            setOpenWriteToUsModel(false);
        }
    };

    const handleSubmitClick = async () => {
        setsubmitButtonLoader(true)
        const trimmedValue = inputValue.trim();

        if (trimmedValue === "") {
            // alert(t("NEED_HELP_WRITE_TO_US_BEF_SUBMIT"));
         message.error(t("NEED_HELP_WRITE_TO_US_BEF_SUBMIT"));
            setsubmitButtonLoader(false);
            return;
        }
        const onlySpecialCharacters = /^[^a-zA-Z0-9]*$/.test(trimmedValue);

if (onlySpecialCharacters) {
    message.error("Only special characters are not allowed.");
    setsubmitButtonLoader(false);
    return;
}


        if (trimmedValue?.length > 500) {
            message.warning("only 500 words allowed");
            setsubmitButtonLoader(false);
            return;
        }
// const payload = {
//     "emailBody":trimmedValue
// }

        const payload = {
            supplierId: user?.userId,
            category: modalDescription,
            moveDate: new Date().toISOString().split('T')[0],
            fromLocation: '',
            toLocation: '',
            orderNumber: modalTitle || "",
            noOfTrucks: '0',
            remarks: trimmedValue
        };

        try {
           const response= await RaiseComplaints(payload);
        // const response = await SendHelpSupportMail(payload);
            setComplainId(response?.data?.data)
            message.success("Your request has been submitted. Our team will reach out to you.")
            setsubmitButtonLoader(false)
            setOpenWriteToUsModel(false)
            // setSubmitModel(true);
        } catch (error) {
            message.error(t("NEED_HELP_DFO_ERROR_SUBMITTING"));
            console.error("Error while submitting complaint:", error);
        }
    };

    const handleCloseClick = () => {
        setOpenWriteToUsModel(false);
        setSubmitModel(false);
    };

    const handleInputChange = (e) => {
        if (e.target.value.length <= 500) {
            setInputValue(e.target.value);
        } else {
            message.warning(t("NEED_HELP_WRITE_TO_US_LIMIT"));
        }
    };

    return (
        <div className="write-to-us-wrapper" id="write-to-us-wrapper" onClick={handleOutsideClick}>
            <div className="write-to-us-edit-model">
                <Row className="write-to-us">
                    <span className="write-to-us-text">{modalTitle}</span>
                    <span>
                        <img src={CloseIcon} onClick={() => setOpenWriteToUsModel(false)} alt="close" style={{ cursor: 'pointer' }} />
                    </span>
                </Row>

                <Row className="team-reach-row">
                    <span className="image-call">
                        <img src={CallIcon} alt="call" />
                    </span>
                    <span className="message-text">{t("NEED_HELP_DFO_TEAM_REACH")}</span>
                </Row>

                <Row className="order-id-missing">{modalDescription}</Row>

                <Row className="input-field">
                    <label className="input-label">{t("NEED_HELP_WRITE_TO_US")}</label>
                    <textarea
                        type="text"
                        className="text-field-main"
                        value={inputValue}
                        onChange={handleInputChange}
                        maxLength={500}
                        placeholder="Write to us"
                    />
                    <span className="char-count">{inputValue.length} / 500</span>
                </Row>

                <Row className="btn-row">
                    <Button disabled={submitButtonLoader} className="cancle-btn"  onClick={() => setOpenWriteToUsModel(false)}>
                        {t("COMMON_CANCEL_BTN")}
                    </Button>
                    <Button loading={submitButtonLoader} className="submit-btn" onClick={handleSubmitClick}>
                        {t("COMMON_SUBMIT_BTN")}
                    </Button>
                </Row>
            </div>

            {submitModel && (
                <div className="write-to-us-wrapper">
                    <div className="write-to-us-submit-model">
                        <div className={`modal ${submitModel ? "open" : ""}`}>
                            <Row className="submitcheckbox">
                                <img src={SubmitCheckbox} alt="submit" />
                            </Row>
                            <Row className="successfull-msg">
                                {t("NEED_HELP_DFO_COMPLAINT_RAISED_SUCCESS")}
                                <span className="modal-title">complainID :{complaintId} against</span>
                                <span className="modal-title">{modalTitle}</span>
                            </Row>
                            <Row className="teams-msg">
                                {t("NEED_HELP_DFO_TEAM_REACH")}
                            </Row>
                            <Row className="close-btn-wrapper">
                                <Button className="close-btn" onClick={handleCloseClick}>
                                    {t("NEED_HELP_DFO_CLOSE")}
                                </Button>
                            </Row>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default WriteToUs;
